import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { UserInfoService } from './user-info.service';
import { UiConfigService } from './ui-config.service';
import { UiVisualCustomizationService } from './ui-visual-customization.service';

@Injectable({
  providedIn: 'root',
})
export class RequiredConfigurationService {
  readonly configurations$: Observable<(object | null)[]>;

  constructor(
    private userInfoService: UserInfoService,
    private uiConfigService: UiConfigService,
    private uiVisualCustomizationService: UiVisualCustomizationService,
  ) {
    this.configurations$ = combineLatest([
      this.userInfoService.userInfo$,
      this.uiConfigService.uiConfig$,
      this.uiVisualCustomizationService.uiVisualCustomization$,
    ]);
  }
}
